import React from 'react';

interface Props {
  className?: string;
}

const KeyIcon = (props: Props) => {
  return (
    <svg height="20" width="20" fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.5 15.8333C9.80119 15.8333 11.6667 13.9679 11.6667 11.6667C11.6667 9.36548 9.80119 7.5 7.5 7.5C5.19881 7.5 3.33334 9.36548 3.33334 11.6667C3.33334 13.9679 5.19881 15.8333 7.5 15.8333Z"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path d="M10.4167 8.75L16.6667 2.5" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M14.1667 5L16.25 7.08333" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
    </svg>
  );
};

export default KeyIcon;
